import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useDummyCreateVideoCallMutation as useDummyCreateVideoCallMutationType } from "@/modules/video-call/services/__generated__/useDummyCreateVideoCallMutation.graphql"

const dummyCreateVideoCallMutation = graphql`
  mutation useDummyCreateVideoCallMutation($input: DummyStartVideoCallInput!) {
    dummyStartVideoCall(input: $input) {
      dummyStartVideoCallOutput {
        roomSid
        sofiaUserToken
        patientToken
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDummyCreateVideoCallMutation = () => {
  const [commit, isFlight] = useMutation<useDummyCreateVideoCallMutationType>(dummyCreateVideoCallMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDummyCreateVideoCallMutationType>) => {
      commit(config)
    },
    [commit],
  )
  return [commitHandler, isFlight] as const
}

export { useDummyCreateVideoCallMutation }
